import tippy from "tippy.js";

document.addEventListener("DOMContentLoaded", () => {
  tippy("[data-tippy-content]", {
    theme: "light-border",
  });
});
